import ContactAdvertise from "@components/pages/contact/contact-advertise"
import ContactCover from "@components/pages/contact/contact-cover"
import ContactList from "@components/pages/contact/contact-list"
import ContactMaps from "@components/pages/contact/contact-maps"
import { getPageBySlug } from "lib/api"
import { metaDesc } from "src/helper/meta-desc"
import { convertJson, extractMeta } from "src/mixins"

function ContactPage({ data, locale }) {
  const pageData = data?.meta
  const list = extractMeta(pageData, "contacts")
  const maps = extractMeta(pageData, "contact_address")
  return (
    <>
      <ContactCover data={data} locale={locale} />
      <ContactList data={convertJson(list?.items)} locale={locale} />
      <ContactMaps data={maps} locale={locale} />
      <ContactAdvertise />
    </>
  )
}
export default ContactPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const data = await getPageBySlug("contact-us")
  return {
    props: {
      seo: {
        title: data[`title_${locale}`] || "Contact Us",
        description: metaDesc[`contact_${locale}`],
      },
      page: "Contact",
      data,
      locale,
    },
    revalidate: 60,
  }
}
